var map = {
	"./goldcoin/earn-head-icon-gift.png": 97256,
	"./memetown/earn-head-icon-gift.png": 46815,
	"./reflection/earn-head-icon-gift.png": 97592,
	"./tapcoin/earn-head-icon-gift.png": 59216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35156;